export default 'tizenmobile';
